module.exports = __webpack_public_path__ + "img/lightPruple.1f082cdc.svg";